<template>
  <div class="test-page">
    <div class="div1" @click="clickOpenLoc">打开位置</div>
  </div>
</template>

<script>
import util from "@/utils/utils.js";

export default {
  data() {
    return {};
  },
  methods: {
    clickOpenLoc() {
      // util.browser.versions.wxwork
      util.wx.openLocation({
        latitude: parseFloat(39),
        longitude: parseFloat(116),
        name: "北京",
        address: "北京",
        scale: 16,
        infoUrl: "",
      });
    },
  },
  created() {
    let tmpInterval = setInterval(() => {
      if (document.getElementById("index_scrim")) {
        document.getElementById("index_scrim").style.display = "none";
        clearInterval(tmpInterval);
      }
    }, 100);
    util.wxsdk.init();
  },
  mounted() {},
};
</script>

<style>
.div1 {
  width: 90%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 20px auto;
  border: 1px solid red;
}
</style>